import { render } from "./TheCongTy.vue?vue&type=template&id=d43e1484"
import script from "./TheCongTy.vue?vue&type=script&lang=js"
export * from "./TheCongTy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__